import { createContext, useContext } from 'react'

export interface FieldContextValue {
  id: string
  describedBy: string | undefined
  invalid: boolean
  required: boolean
}

export const FieldContext = createContext<FieldContextValue | null>(null)

/** Inputs read their id / aria wiring from the surrounding <Field>. */
export function useFieldControl(): FieldContextValue | null {
  return useContext(FieldContext)
}
